/** @jsx jsx */
import { jsx } from "theme-ui";
import React from "react";

export type HtmlProps = {
  html: string;

  sx?: any; //we expect a sx prop but never use it below
  className?: string; //we expect a className prop but never define one when the component is called
};
export const HtmlContent: React.FC<HtmlProps> = ({ html, className }) => {
  return (
    <div
      className={`whitespace-pre-wrap ${className}`}
      dangerouslySetInnerHTML={{
        __html: html,
      }}
    />
  );
};

export const HtmlContentStyled: React.FC<HtmlProps> = ({ html, className }) => {
  return (
    <div
      sx={{ variant: "styles" }}
      className={`whitespace-pre-wrap ${className}`}
      dangerouslySetInnerHTML={{
        __html: html,
      }}
    />
  );
};

export default HtmlContent;
